/*
 * @Description:
 * @Date: 2021-06-17 15:05:33
 */
export default {
  serviceScale: {
    label: '服务费率',
    prop: 'serviceScale',
    formatter(r, c, v) {
      return !+v ? '-' : v + '%';
    }
  },
  payStatus: {
    label: '支付状态',
    prop: 'payStatus',
    width: '120px',
    render: (h, ctx, r) => {
      const getPayLabel = () => {
        const { closeOrRgStatus, closeOrRgType } = r;
        if (+closeOrRgStatus === 2) {
          if (+closeOrRgType === 1) return '关闭支付';
          if (+closeOrRgType === 2) return '线下支付完成';
        } else {
          return ['未支付', '支付中', '支付成功', '支付失败'][r.payStatus || 0];
        }
      };
      return (
        <div>
          <span>{getPayLabel()}</span>
        </div>
      );
    }
  }
};
